import AppointmentsHeaderCell from "./AppointmentsHeaderCell"
import { appointments_table_header_cells } from "../../assets/data"

export default function AppointmentsHeader({isInTab}) {
    
    return <thead>
        <tr>
            {/* .filter(item => isInTab ? item.id !=1 : item) */}
            {/* if we are on tab and not on history page, remove the NG# and person name!!!  */}
            {appointments_table_header_cells && appointments_table_header_cells.filter(item => isInTab ? (item.id !=22 && item.id != 333) : item).map(item => (
                <th key={item.id} >
                    <AppointmentsHeaderCell item={item}/>
                </th>
            ))}
        </tr>
    </thead>
}